import React, { useState } from 'react';

import { GMetrixDropdown } from 'components/GMetrixDropdown/GMetrixDropdown';
import { License, SupplierOption } from 'apis/LicenseApi';

import 'components/LicenseGMetrixTableDialog/SuppliedByDropdown/supplied-by-dropdown.scss';

interface SuppliedByDropdownProps {
    currentSupplier: SupplierOption;
    license: License;
    licenses: License[];
    setLicenses: React.Dispatch<React.SetStateAction<License[]>>
    supplierOptions: SupplierOption[]
    updateLicenseSupplier: (supplier: SupplierOption, licenseId: number) => void;
}

export function SuppliedByDropdown({
    currentSupplier,
    license,
    licenses,
    setLicenses,
    supplierOptions
}: SuppliedByDropdownProps) {

    const updateLicenseSupplier = (supplier: SupplierOption, licenseId: number) => {

        const newSetOfLicenses = [...licenses];
        const licenseIndex = newSetOfLicenses.findIndex(license => license.Id === licenseId);
        newSetOfLicenses[licenseIndex].SuppliedBy = supplier.Id;
        newSetOfLicenses[licenseIndex].SuppliedByName = supplier.Name;
        setLicenses(newSetOfLicenses);

    };

    return (
        <td>
            {supplierOptions.length > 1 ? (
                <GMetrixDropdown

                    // limitMenuWidth
                    onChange={dataItem => {

                        updateLicenseSupplier(dataItem, license.Id);

                    }}
                    dataItemKey={'Id'}
                    dataItems={supplierOptions}
                    textField={'Name'}
                    value={currentSupplier}
                />
            ) : (
                <div className="p-2">
                    {license.SuppliedByName}
                </div>
            )}
        </td>
    );

}
